function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "122",
  height: "37",
  viewBox: "0 0 122 37",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.49 1.582v-.01c-.095-.266-.354-.39-.573-.275L9.827 3.43a.541.541 0 00-.235.295c-.087.277.023.581.25.696.103.047.22.047.338-.01l4.082-2.134c.228-.114.33-.429.228-.696zm-4.93 10.49l-1.962-2.029-1.319.677c-.267.133-.565-.01-.675-.334-.11-.314.016-.676.275-.81l.856-.438-1.374-1.42-1.429 1.22-1.467 1.239a4.384 4.384 0 00-.777.905 4.73 4.73 0 00-.51 1.143c-.103.334-.15.639-.158.896 0 .152.016.343.063.419.047.095.196.2.416.314.26.143.597.258.973.343.471.096 1.029.143 1.594.086a4.487 4.487 0 001.436-.371c1.358-.61 2.708-1.22 4.058-1.84zm1.327-.257c.29.296.22.887-.15 1.049-1.624.743-3.249 1.476-4.874 2.21a5.22 5.22 0 01-1.719.448c-.659.066-1.295.019-1.844-.105a4.383 4.383 0 01-1.209-.42c-.392-.209-.69-.466-.856-.752C.11 13.978 0 13.683 0 13.092c.008-.39.078-.838.212-1.277.141-.485.361-1 .667-1.486.267-.42.597-.82 1.005-1.162 1.067-.915 2.143-1.83 3.21-2.744a.44.44 0 01.628.038l1.452 1.505V5.117a.65.65 0 01.314-.571l1.052-.543a2.254 2.254 0 01.102-.734c.141-.429.416-.781.785-.981L13.61.106c.73-.324 1.523.123 1.821.981.322.896-.023 1.953-.761 2.334l-4.09 2.135c-.368.19-.769.19-1.114.019a1.466 1.466 0 01-.526-.43l-.738.382v3.497l2.685 2.791z",
  id: "path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "beta-copy-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(2 6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M104.146 12.761L111.725 26H6a7 7 0 01-7-7V6a7 7 0 017-7h105.688l-7.542 13.761z",
  id: "Rectangle-6",
  stroke: "#FFF",
  strokeWidth: "2",
  fill: "#910155"
}), /*#__PURE__*/React.createElement("text", {
  id: "Vorl\xE4ufig",
  fontFamily: "OpenSans-Bold, Open Sans",
  fontSize: "14",
  fontWeight: "bold",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: "27",
  y: "17"
}, "Vorl\xE4ufig")), /*#__PURE__*/React.createElement("g", {
  id: "icon/phase/bau",
  transform: "translate(6 4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_1547539_cc"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#1A1A1A",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "color/white",
  mask: "url(#mask-2)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15.916v18.9H0z",
  transform: "matrix(-1 0 0 1 15.552 -1.414)",
  id: "Rectangle"
})))))))));